var __gh__coreData										= __gh__coreData || {};
	__gh__coreData.globalVariables				 		= __gh__coreData.globalVariables || {};
	__gh__coreData.globalVariables.ads				 	= __gh__coreData.globalVariables.ads || {};
	__gh__coreData.globalVariables.ads.isAdBlockOn 		= (typeof(defslot_a) === "undefined") ? true : false;
	__gh__coreData.globalVariables.article				= __gh__coreData.globalVariables.article || {};
	__gh__coreData.globalVariables.article.loadArticle	= __gh__coreData.globalVariables.article.loadArticle || {};


var __gh__adsLoaded		= false;